import { erpAxios, getAuthToken } from "../axiosInstances";

export interface SummaryCardResponse {
    title: string | null;
    count: number | null;
    percentageChange: number | null;
    status: string | null;
    filterParam: string | null;
}

export interface SalesStatusResponse {
    fulfillmentRate: number | null;
    percentageChange: number | null;
    totalSalesOrders: number | null;
    completedSalesOrders: number | null;
    pendingSalesOrders: number | null;
}

export interface StatusResponse {
    label: string | null;
    status: string | null;
    count: number | null;
    percentage: number | null;
}

export interface DashboardSummary {
    userName: string;
    franchiseName: string;
    poOpen: SummaryCardResponse;
    poApproved: SummaryCardResponse;
    poCompleted: SummaryCardResponse;
    salesStatus: SalesStatusResponse;
    totalOrders: SummaryCardResponse;
    totalPoCount: number;
    poStatusOverview: StatusResponse[];
}

export interface GetDashboardSummaryApiResponse {
    code: number;
    message: string;
    data: DashboardSummary;
}

export interface RecentOrder {
    id: number | string;
    orderNumber: string | null;
    orderType: string | null;
    rawType: string | null;
    partyName: string | null;
    date: string | null;
    dateFormatted: string | null;
    status: string | null;
    statusDisplayName: string | null;
    amount: number | null;
}

export interface GetRecentOrdersApiResponse {
    code: number;
    message: string;
    data: RecentOrder[];
}

export class DashboardApi {
    public static api = new DashboardApi();
    private instance = erpAxios;

    getToken() {
        return getAuthToken();
    } 
    
    async getDashboardSummary(startDate?: string, endDate?: string): Promise<GetDashboardSummaryApiResponse> {
        try{
            const response = await this.instance.get('/erp/api/v1/dashboard/franchise/summary',{
                headers:{
                    Authorization: `Bearer ${this.getToken()}`,
                },
                params: {
                    startDate,
                    endDate,
                }
            });
            return response.data;

        }catch(error){
            console.error("Error fetching dashboard summary", error);
            throw error;
        }
    }

    async getRecentOrders(startDate?: string, endDate?: string): Promise<GetRecentOrdersApiResponse> {
        try {
            const response = await this.instance.get('/erp/api/v1/dashboard/franchise/recent-orders', {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
                params: {
                    startDate,
                    endDate,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching recent dashboard orders", error);
            throw error;
        }
    }
}